import React, { memo } from 'react';
import selectStyles from '@lib/utils/selectStyles';
import loader from './loader_200.gif';
import defaultStyles from './Default.module.scss';

export enum Types {
  GIF = 'gif',
  SVG = 'svg',
}

export interface Props {
  color?: string;
  strokeWidth?: number;
  size?: number;
  padding?: string | number;
  classes?: Record<string, string>;
  type?: Types;
}

function CircleLoader(props: Props) {
  const {
    color = '#214EEB',
    strokeWidth = 2,
    size = 24,
    padding = '25px 0',
    classes,
    type = Types.SVG,
  } = props;
  const styles = selectStyles(defaultStyles, classes);
  const center = size / 2;
  const radius = center - strokeWidth * 2;
  const circumference = 2 * Math.PI * radius;
  const strokeDasharray = `${circumference / 1.5} ${circumference / 0.5}`;
  return (
    <div
      className={styles.root}
      style={{ padding }}
      data-test-id="circle-loader"
    >
      {type === Types.GIF && (
        <img src={loader} alt="loader" style={{ width: size, height: size }} />
      )}
      {type === Types.SVG && (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={size}
          height={size}
          viewBox={`0 0 ${size} ${size}`}
          style={{ width: size, minWidth: size, height: size }}
          preserveAspectRatio="xMidYMid"
        >
          <circle
            cx={center}
            cy={center}
            r={radius}
            fill="none"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeDasharray={strokeDasharray}
            strokeDashoffset="0"
          >
            <animateTransform
              attributeName="transform"
              type="rotate"
              from={`0 ${center} ${center}`}
              to={`360 ${center} ${center}`}
              dur="1s"
              repeatCount="indefinite"
            />
          </circle>
        </svg>
      )}
    </div>
  );
}

export default memo(CircleLoader);
